var config = {
  apiKey: "AIzaSyBim0H6E-dHEkTcXIeNw2RfhER1DgNl_0A",
  authDomain: "foncierpublic-ecd11.firebaseapp.com",
  databaseURL: "https://foncierpublic-ecd11.firebaseio.com",
  projectId: "foncierpublic-ecd11",
  storageBucket: "foncierpublic-ecd11.appspot.com",
  messagingSenderId: "934419921767",
  appId: "1:934419921767:web:58c91b28dce74bce608dc2",
  measurementId: "G-BT341MD94Q"
};

export { config };
